import { ButtonContainer, makeTraceDetails, Page, PageContent } from 'common'
import { ChipBottomSheet, ErrorHandler, Header, SignalFeedback } from 'components'
import { ChipFilter } from 'components/chip-filter'
import { Routes } from 'common/constants'
import { Button } from 'common/styles/layouts'
import { Loading } from 'components/loader/components/Loader'

import IcChevronDown from '@interco/icons/core/action-navigation/ic_chevron_down'
import { Text } from '@interco/inter-ui/components/Text'

import {
  ChipContainer,
  MyServicesContainer,
  RefreshIndicatorContainer,
  UpdateScrollContainer,
} from '../styles/MyServices.styles'
import { useMyServiceContent } from '../hooks/useMyService'
import { MyServicesView } from './MyServiceView'
import { MyServicesSkeleton } from './MyServices.skeleton'

const FILTER_COMPONENT: 'chip-filter' | 'bottom-sheet' = 'chip-filter'

const PullRefreshIndicator = () => (
  <RefreshIndicatorContainer>
    <IcChevronDown color="var(--secondary500)" width={16} height={16} />
    <Text as="span" variant="caption-1" color="typography" colorWeight={400}>
      Deslize para atualizar
    </Text>
  </RefreshIndicatorContainer>
)

export function MyServices() {
  const {
    pageTitle,
    newSupportButtonLabel,
    emptyRequest,
    emptyFilter,
    filteredServices,
    isEmpty,
    isLoading,
    hasScroll,
    ref,
    isActive,
    content,
    isError,
    isEmptyFilter,
    filterSections,
    isBottomSheetOpen,
    chipFilterProps,
    chipBottomSheetProps,
    onClick,
    refetch,
  } = useMyServiceContent()

  if (isError) {
    const traceDetails = makeTraceDetails(isActive, content)

    return (
      <ErrorHandler
        traceDetails={traceDetails}
        componentName={MyServices.name}
        goTo={Routes.HOME}
      />
    )
  }

  if (isLoading) {
    return <MyServicesSkeleton pageTitle={pageTitle} />
  }

  return (
    <Page>
      <Header title={pageTitle} goToPath={Routes.HOME} />
      <UpdateScrollContainer
        isPullable={!isBottomSheetOpen}
        onRefresh={async () => {
          await refetch()
        }}
        pullingContent={<PullRefreshIndicator />}
        refreshingContent={<Loading />}
      >
        {!isEmpty && filterSections.length > 0 && (
          <ChipContainer>
            {FILTER_COMPONENT === 'bottom-sheet' ? (
              <ChipBottomSheet {...chipBottomSheetProps} />
            ) : (
              <ChipFilter {...chipFilterProps} />
            )}
          </ChipContainer>
        )}
        <PageContent ref={ref}>
          {isEmpty ? (
            <SignalFeedback
              icon={emptyRequest.icon}
              title={emptyRequest.title}
              details={emptyRequest.subtitle}
              type={emptyRequest.type}
            />
          ) : (
            <MyServicesContainer $isEmpty={isEmptyFilter}>
              {isEmptyFilter ? (
                <SignalFeedback
                  icon={emptyFilter.icon}
                  title={emptyFilter.title}
                  details={emptyFilter.subtitle}
                  type={emptyFilter.type}
                />
              ) : (
                <MyServicesView items={filteredServices} />
              )}
            </MyServicesContainer>
          )}
          <ButtonContainer $hasScroll={hasScroll}>
            <Button fullWidth onClick={onClick}>
              {newSupportButtonLabel}
            </Button>
          </ButtonContainer>
        </PageContent>
      </UpdateScrollContainer>
    </Page>
  )
}
